query GooglePlaces($input: GooglePlacesInput!) {
  getGooglePlaces(input: $input) {
    description
    placeId
  }
}
